var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadInlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.75,
    height: 22.052,
    viewBox: "0 0 21.75 22.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0.25 0.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M2.9,7.162,9.124,1.385a.759.759,0,0,1,1.033,0l6.221,5.777",
    transform: "translate(0.985)",
    fill: "none",
    stroke: "#3c424a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M7.341,2V15.956",
    transform: "translate(3.284 0.423)",
    fill: "none",
    stroke: "#3c424a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M1,10.512V12.77a3.036,3.036,0,0,0,3.036,3.036H17.214A3.036,3.036,0,0,0,20.25,12.77V10.512",
    transform: "translate(0 4.831)",
    fill: "none",
    stroke: "#3c424a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadInlineIcon);
export default __webpack_public_path__ + "static/media/upload-inline-icon.c90575b98338f0350c4b0d85a18f0f72.svg";
export { ForwardRef as ReactComponent };